import { SiteEquipmentAdd } from "../../../../components/Site/Equipment/SiteEquipmentAdd";
import { formDataType } from "../AddSite";
import React, { useState } from "react";
import { Equipment } from "../../../../models/equipment.interface";
import useApiService from "../../../../hooks/useApiService";
import styles from "../add-site.module.css";
import { Checkbox } from "../../../../components/Shared/Forms";
import { ProgressSpinner } from "primereact/progressspinner";
import { capitaliseFirstLetter } from "../../../../utils/generalUtils";

interface EquipmentAndToolsProps {
  handleChange: (name: string, value: string[]) => void;
  formData: formDataType;
}

export function EquipmentAndTools({ handleChange, formData }: EquipmentAndToolsProps) {
  const [equipmentData, setEquipmentData] = useState<Equipment[]>([]);
  const [selectedEquipment, setSelectedEquipment] = useState<string[]>([]);
  const [rowClick, __] = useState(true);
  const [allSelected, setAllSelected] = useState<boolean>(false);

  function handleSelectionChange(e: Equipment) {
    const isSelected = selectedEquipment.includes(e.id);

    if (isSelected) {
      setSelectedEquipment(selectedEquipment.filter(equipment => equipment !== e.id));
      handleChange(
        "equipment",
        selectedEquipment.filter(equipment => equipment !== e.id)
      );
      return;
    }

    setSelectedEquipment([...selectedEquipment, e.id]);
    handleChange("equipment", [...selectedEquipment, e.id]);
  }

  function handleAllSelected() {
    if (!allSelected) {
      setSelectedEquipment(equipmentData.map(item => item.id));
      handleChange(
        "equipment",
        equipmentData.map(item => item.id)
      );
      return;
    }

    setSelectedEquipment([]);
    handleChange("equipment", []);
  }

  const { loading: loadingEquipment } = useApiService<Equipment[]>({
    method: "GET",
    url: "equipment",
    apiName: "core",
    onSuccess: data => {
      // get selected equipment from form data
      const selected = data
        .filter(equipment => formData.equipment?.includes(equipment.id))
        .map(equipment => equipment.id);

      setSelectedEquipment(selected);
      setEquipmentData(data);
    },
  });

  return (
    <div>
      <p className={"my-4"}>Select all tools and equipment that will be used on this site.</p>
      {loadingEquipment ? (
        <div
          style={{
            width: "100%",
            height: "500px",
            backgroundColor: "rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        />
      ) : (
        <>
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Checkbox
              checked={allSelected}
              onChange={() => {
                setAllSelected(!allSelected);
                handleAllSelected();
              }}
              label={"Select all"}
            />
          </div>
          <div className={styles["responsive-grid-3"]}>
            {equipmentData.map((item, index) => {
              return (
                <div key={index} className={styles["check-item"]}>
                  <Checkbox
                    checked={selectedEquipment.includes(item.id)}
                    label={capitaliseFirstLetter(item.name)}
                    onChange={() => handleSelectionChange(item)}
                  />
                  <span>
                    {item.serial_number && `${item.serial_number} | `} {item.type}
                  </span>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
